import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c443eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100 p-text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Edit Brand Info")
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "p-grid p-d-flex p-flex-column p-p-4" }
const _hoisted_4 = { class: "p-grid p-d-flex p-flex-column p-p-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Brand Name", -1))
const _hoisted_6 = { class: "p-grid p-d-flex p-flex-column p-p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Brand Description", -1))
const _hoisted_8 = { class: "p-d-flex p-justify-between p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalWorkingOverlay = _resolveComponent("ModalWorkingOverlay")!
  const _component_photo_gallery = _resolveComponent("photo-gallery")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_cropper_image = _resolveComponent("cropper-image")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.show,
      class: "p-col-12 p-md-6 p-xl-4 gi-dialog",
      modal: true,
      style: { width: '40vw' },
      dismissableMask: !_ctx.working,
      closable: !_ctx.working,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:show', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-link p-ml-6",
            disabled: _ctx.working,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show', false)))
          }, null, 8, ["disabled"]),
          _createElementVNode("div", null, [
            _createVNode(_component_cropper_image, {
              "show-crop": _ctx.showCrop,
              "onUpdate:showCrop": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showCrop) = $event)),
              "user-view": true,
              image: _ctx.photo,
              onChange: _ctx.cropMainImage
            }, null, 8, ["show-crop", "image", "onChange"]),
            _createVNode(_component_Button, {
              label: "Crop image",
              class: "p-button-text p-button-danger gi-button p-text-uppercase p-mr-6",
              disabled: _ctx.working,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCrop = !_ctx.showCrop))
            }, null, 8, ["disabled"]),
            _createVNode(_component_Button, {
              label: "Save",
              class: "p-button-text p-button-danger gi-button p-text-uppercase p-mr-6",
              loading: _ctx.working,
              disabled: _ctx.working,
              onClick: _ctx.saveBrand
            }, null, 8, ["loading", "disabled", "onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.working)
            ? (_openBlock(), _createBlock(_component_ModalWorkingOverlay, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_photo_gallery, {
              class: "gallery",
              type: "campaign",
              photo: _ctx.photo,
              "onUpdate:photo": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.photo) = $event))
            }, null, 8, ["photo"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              class: "tittle-input",
              type: "text",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              placeholder: "Enter brand slogan"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Textarea, {
              class: "textarea",
              modelValue: _ctx.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
              rows: "5",
              cols: "30",
              placeholder: "Enter brand description"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "dismissableMask", "closable"])
  ]))
}